(() => {
  'use strict';
  const config = document.querySelector('#CommerceConfig');
  const api = window.BeerClubCommerce;
  if (!config || !api) return;
  const client = api.createClient(JSON.parse(config.textContent));
  const requests = new WeakMap();
  function reset(widget) {
    requests.get(widget)?.abort();
    requests.delete(widget);
    widget.removeAttribute('aria-busy');
    widget.querySelector('[data-shipping-results]').replaceChildren();
    widget.querySelector('[data-shipping-zip]').removeAttribute('aria-invalid');
    const button = widget.querySelector('[data-product-shipping]');
    button.disabled = false;
    button.textContent = 'Calcular';
  }
  async function quote(widget) {
    reset(widget);
    const input = widget.querySelector('[data-shipping-zip]');
    const output = widget.querySelector('[data-shipping-results]');
    try { api.address(input.value); } catch (error) {
      input.setAttribute('aria-invalid', 'true');
      output.textContent = error.message;
      input.focus();
      return;
    }
    const form = widget.closest('.product-page')?.querySelector('.native-product-form');
    if (!form || !form.querySelector('[name="quantity"]').reportValidity()) return;
    const plan = form.querySelector('[name="selling_plan"] option:checked');
    const item = {
      variant_id: form.querySelector('[name="id"]').value,
      quantity: Number(form.querySelector('[name="quantity"]').value),
      grams: Number(widget.dataset.grams),
      price: Number(plan?.dataset.price || widget.dataset.price)
    };
    const controller = new AbortController();
    requests.set(widget, controller);
    widget.dataset.shippingQueried = 'true';
    widget.setAttribute('aria-busy', 'true');
    const button = widget.querySelector('[data-product-shipping]');
    button.disabled = true;
    button.textContent = 'Calculando…';
    output.textContent = 'Consultando frete…';
    try {
      const rates = await client.productShipping(input.value.trim(), item, widget.dataset.currency, controller.signal);
      if (controller.signal.aborted) return;
      if (!rates.length) { output.textContent = 'Nenhuma entrega disponível para este CEP.'; return; }
      window.BeerClubShippingView.render(widget, rates, widget.dataset.currency);
    } catch (error) {
      if (!controller.signal.aborted) output.textContent = error.message;
    } finally {
      if (requests.get(widget) === controller) {
        requests.delete(widget);
        widget.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = 'Calcular';
      }
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-product-shipping]');
    if (button) quote(button.closest('[data-shipping-product]'));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('[data-shipping-zip]')) return;
    event.preventDefault();
    event.target.closest('[data-shipping-estimator]').querySelector('[data-product-shipping], [data-shipping-calculate]')?.click();
  });
  document.addEventListener('input', event => {
    const widget = event.target.closest('[data-shipping-product]');
    if (widget && event.target.matches('[data-shipping-zip]')) {
      reset(widget);
      delete widget.dataset.shippingQueried;
      const digits = event.target.value.replace(/\D/g, '').slice(0, 8);
      event.target.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    }
    if (event.target.matches('.native-product-form [name="quantity"], .native-product-form [name="selling_plan"]')) {
      event.target.closest('.product-page')?.querySelectorAll('[data-shipping-product]').forEach(reset);
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.native-product-form [name="quantity"], .native-product-form [name="selling_plan"]')) return;
    event.target.closest('.product-page')?.querySelectorAll('[data-shipping-product]').forEach(widget => {
      const recalculate = widget.dataset.shippingQueried === 'true';
      reset(widget);
      if (recalculate) quote(widget);
    });
  });
})();
